import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordUpdateComponent } from './password-update.component';
import { PasswordModule } from 'primeng/password';
import { PasswordUpdateFooterComponent } from './footer/password-update.footer.component';

@NgModule({
    declarations: [PasswordUpdateComponent, PasswordUpdateFooterComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        PasswordModule,
    ],
    exports: [
        PasswordUpdateComponent,
        PasswordUpdateFooterComponent
    ]
})
export class PasswordUpdateModule { }
